import styled from "styled-components/macro";
import ButtonStyled from "./ButtonStyled";

const BreadcrumbsButtonStyled = styled(ButtonStyled)`
  color: ${({ theme }) => theme.colors.darkOpacity};
`;

export default BreadcrumbsButtonStyled;
